// src/components/ui/AdminMessagesHeader.jsx
import React from "react";

const AdminMessagesHeader = ({
  title = "מרכז הודעות",
  subtitle = "ניהול הודעות משתמשים: צפייה, חיפוש, מענה וסינון סטטוסים",
  unrepliedCount = 0, // badge
}) => {
  const hasUnreplied = Number(unrepliedCount || 0) > 0;

  return (
    <section className="mx-auto max-w-7xl px-2 sm:px-4 md:px-6 lg:px-8 py-3" dir="rtl">
      <div className="relative overflow-hidden rounded-3xl">
        {/* soft gradient background */}
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-50 via-purple-25 to-blue-50" />

        {/* content card */}
        <div className="relative bg-white/80 backdrop-blur-xl border border-white/60 rounded-3xl p-6 shadow-2xl shadow-indigo-100/50">
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-4 min-w-0">
              {/* icon block */}
              <div className="relative flex-shrink-0">
                <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 text-white flex items-center justify-center shadow-md">
                  <svg
                    viewBox="0 0 24 24"
                    className="w-6 h-6"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1.8"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4"
                    />
                  </svg>
                </div>

                {hasUnreplied && (
                  <div className="absolute -top-2 -right-2 w-6 h-6 bg-red-500 rounded-full flex items-center justify-center text-white text-xs font-bold animate-bounce">
                    {unrepliedCount}
                  </div>
                )}
              </div>

              {/* text */}
              <div className="min-w-0">
                <h1 className="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-gray-900 via-indigo-800 to-purple-800 bg-clip-text text-transparent leading-tight">
                  {title}
                </h1>
                <p className="text-gray-600 mt-1 truncate">{subtitle}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdminMessagesHeader;
